import { useCallback } from 'react';
import get from 'lodash/get';
import isArray from 'lodash/isArray';

import { useUserData } from 'utils/hooks/useAuthenticatedUser';
import useGetTargetProfile from 'utils/hooks/useGetTargetProfile';
import { ENTITY_TYPES } from 'operabase-router/constants';
import usePermissions from './permissions';
import { PRIVACY_ATTRIBUTE_IDS as PAI } from '../constants/consts';

function usePrivacyAttributes(_, forceShow) {
  const user = useUserData();
  const { profileData } = useGetTargetProfile();
  const { isAdmin, castingToolPermissions } = usePermissions();

  const canSee = useCallback(
    privacyAttributesArray => {
      if (isAdmin || forceShow) return true;
      if (!isArray(privacyAttributesArray) || privacyAttributesArray.length === 0) return false;
      const pattrIds = privacyAttributesArray.map(pa => pa?.id);
      if (pattrIds.includes(PAI.PRIVATE)) return false;
      if (pattrIds.includes(PAI.PUBLIC)) return true;
      if (pattrIds.includes(PAI.FREE_AND_PRO) && user?.id) return true;
      if (pattrIds.includes(PAI.PRO) && user?.id && get(profileData?.profile, 'isPro', true)) return true;
      if (pattrIds.includes(PAI.CASTING) && castingToolPermissions?.hasAccess) return true;
      if (pattrIds.includes(PAI.ARTISTS) && profileData?.entityType === ENTITY_TYPES.PROFILE) return true;
      if (pattrIds.includes(PAI.AOS) && profileData?.entityType === ENTITY_TYPES.ORGANIZATION) return true;
      return pattrIds.includes(PAI.AGENCY) && profileData?.entityType === ENTITY_TYPES.AGENCY;
    },
    [isAdmin, forceShow, user?.id, profileData?.profile, profileData?.entityType, castingToolPermissions?.hasAccess],
  );

  return { canSee };
}

export default usePrivacyAttributes;
